module.exports = __webpack_public_path__ + "4b56f40c193b0b25b8009c111e048307.svg";